<template>
  <AppContainer>
    <form
      autocomplete="off"
      @submit.prevent="submitForm"
    >
      <AppCard>
        <TextInput
          v-model.trim="formData.name"
          v-focus
          :validation-error="getValidationError('name')"
          label="Name"
        />

        <template #buttons>
          <ButtonSubmitRow
            :cancel-route="{ name: 'app_plan_list', params: { district: route.params.district } }"
            :processing="isSubmitting"
          />
        </template>
      </AppCard>
    </form>
  </AppContainer>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { AppContainer } from '@/components/app';
import { ButtonSubmitRow } from '@/components/buttons';
import { AppCard } from '@/components/cards';
import { TextInput } from '@/components/form-inputs';

import { useFormSubmit } from '@/composables';

defineProps({
  model: {
    type: Object,
    default: () => null,
  },
});

const { isSubmitting, submit, getValidationError } = useFormSubmit();
const route = useRoute();
const router = useRouter();

const formData = reactive({
  name: null,
});

const submitForm = async () => {
  const response = await submit(null, formData, null, `districts/${route.params.district}/plans`);

  if (response.statusCode === HttpStatusCode.Ok) {
    await router.push({ name: 'app_plan_list', params: { district: route.params.district } });
  }

  isSubmitting.value = false;
};
</script>
